import React, { useRef, useContext } from "react";
import propTypes from "prop-types";
import { useGSAP } from "@gsap/react";
import Context from "../OriginStoryProvider";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitText from "gsap/SplitText";

const QuoteWithImg = ({ imgSrc, quote, citation, imgCaption, elClass, imgSrcset, imgSizes, imgHeight, imgWidth, imgAlt }) => {

	const {
		data: { content },
	} = useContext(Context);

	const quoteWithImgParentContainer = useRef(null);
	const quoteText = useRef(null);

	useGSAP(
		() => {
			const split = new SplitText(quoteText.current, {
				type: "chars, words",
				wordsClass: "word",
			});

			const tl = gsap
				.timeline()
				.to(`.${elClass}__quote`, {
					"--lquo-opacity": 1,
				})
				.from(split.chars, {
					opacity: 0,
					rotate: (i) => -i * 0.1,
					y: (i) => -i * 0.1,
					skewY: -5,
					stagger: 0.2,
				})
				.from(`.${elClass}__citation`, {
					opacity: 0,
				})
				.to(`.${elClass}__text-container`, {
					yPercent: -100,
					delay: 3,
				})
				.from(
					`.${elClass}__bg-img`,
					{
						opacity: 0.5,
					},
					"<"
				)
				.to({}, { duration: 1 });

			ScrollTrigger.create({
				trigger: quoteWithImgParentContainer.current,
				start: () => "top top",
				pin: quoteWithImgParentContainer.current,
				scrub: 2,
				animation: tl,
			});
		},
		{
			scope: quoteWithImgParentContainer.current,
			dependencies: [content.chapters],
		}
	);

	return (
		<div className={`${elClass}__container`} ref={quoteWithImgParentContainer}>
			<div className="main-grid">
				<img
					className={`${elClass}__bg-img`}
					srcSet={imgSrcset}
					sizes={imgSizes}
					height={imgHeight}
					width={imgWidth}
					alt={imgAlt}
					src={imgSrc}
					loading="lazy"
				/>
				<div className="main-grid__margin"></div>
				<div className="main-grid__body">
					<div className={`${elClass}__text-container`}>
						<p className={`${elClass}__quote headline-quote`} ref={quoteText}>
							{quote}&rdquo;
						</p>
						<cite
							className={`${elClass}__citation quote-attribute`}
							dangerouslySetInnerHTML={{ __html: citation }}
						></cite>
					</div>
				</div>
				<div className="main-grid__margin"></div>
			</div>
			<p className={`${elClass}__img-caption img-caption`}>{imgCaption}</p>
		</div>
	);
};

export default QuoteWithImg;

QuoteWithImg.propTypes = {
	imgSrc: propTypes.string.isRequired,
	quote: propTypes.string.isRequired,
	elClass: propTypes.string.isRequired,
	citation: propTypes.string.isRequired,
	imgCaption: propTypes.string.isRequired,
	imgSrcset: propTypes.string,
	imgSizes: propTypes.string,
	imgHeight: propTypes.string,
	imgWidth: propTypes.string,
	imgAlt: propTypes.string,
};
